import React from 'react'

import Cookie from './Cookie'
import Footer from './Footer'
import Header from './Header'

const Layout = ({ location, children }) => {
  const rootPath = `${__PATH_PREFIX__}/`
  const isRootPath = location.pathname === rootPath

  return (
    <>
        <main>{children}</main>
    </>
  )
}

export default Layout
